// extracted by mini-css-extract-plugin
export default {"mainButton":"button_mainButton__qNZgC","wrapper":"button_wrapper__nyVPb","ghostButton":"button_ghostButton__A9PbI"};